<template>
  <BContainer
    v-if="currentUser"
    class="mb-4"
  >

    <div class="d-flex justify-content-end">
      <BBreadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <BSidebar
      id="sbRsmCustomer"
      backdrop-variant="dark"
      backdrop
      shadow
      right
    >
      <template #title>
        <i class="fad fa-filter-list" /> Filters
      </template>

      <BContainer>
        <BRow
          class="py-2"
        >

          <BCol
            cols="12"
          >
            <BFormGroup
              label="Cluster"
              label-for="filterCluster"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <VSelect
                v-model="tableCustomers.selected.cluster"
                placeholder="filter cluster here"
                input-id="filterCluster"
                label="cluster_name"
                class="border border-light rounded-lg"
                clearable
                append-to-body
                :options="(tableCustomers.options.clusters)"
                :disabled="(tableCustomers.busy)"
                :calculate-position="calculateDropPosition"
              >
                <template #no-options="">
                  no available cluster
                </template>
              </VSelect>
            </BFormGroup>
          </BCol>
        </BRow>
      </BContainer>
    </BSidebar>

    <BRow
      class="py-2"
    >
      <BCol
        cols="12"
      >
        <BFormGroup
          label="Search"
          label-for="filterSearch"
          label-class="font-weight-bolder"
          class="mb-2"
        >
          <BInputGroup>
            <BFormInput
              id="filterSearch"
              v-model="tableCustomers.filter.search"
              placeholder="search here"
              autocomplete="off"
              debounce="1000"
              type="text"
            />
            <BInputGroupAppend>
              <BButton
                v-b-toggle.sbRsmCustomer
                variant="primary"
              >
                <i
                  v-if="[].some(isTrue => isTrue)"
                  class="fad fa-spinner fa-spin p-0"
                />
                <i
                  class="fad fa-filter-list"
                /> Filters
              </BButton>
            </BInputGroupAppend>
          </BInputGroup>
        </BFormGroup>
      </BCol>
      <!-- <BCol
        cols="12"
        class="d-flex flex-row justify-content-between align-items-center gap-2"
      >
        <BButton
          size="sm"
          variant="primary"
          label-for="filterIsCreatedByMe"
          @click.prevent="createCustomer"
        >
          Add Customer
        </BButton>
      </BCol> -->
    </BRow>

    <CustomTable
      ref="tableCustomers"
      class="no-column-before"
      :provider="tableProvider"
      :fields="tableCustomers.fields"
      :filter="tableCustomers.filter"
      :filter-on="tableCustomers.filterOn"
      :sort-by="tableCustomers.sortBy"
      :sort-desc="tableCustomers.sortDesc"
      :sort-direction="tableCustomers.sortDirection"
      :total-rows="tableCustomers.totalRows"
      :current-page="tableCustomers.currentPage"
      :per-page="tableCustomers.perPage"
      :stacked="tableCustomers.stacked"
      :busy="tableCustomers.busy"
    >
      <template #cell(action)="{ item }">
        <div class="w-100 text-md-nowrap d-flex justify-content-md-center justify-content-end">
          <BButton
            size="sm"
            variant="primary"
            :disabled="tableCustomers.busy"
            :to="{
              name: 'fso.customers.profile',
              params: {
                customer: item.id
              }
            }"
          >
            Manage
          </BButton>
        </div>
      </template>

      <template #cell(customer_name)="{ item }">
        <div class="d-flex flex-column gap-1 p-1">
          <div class="font-weight-bolder">
            {{ item.customer_name }}
          </div>
          <div style="font-size: 10px;">
            {{ item.address || 'n/a' }}
          </div>
        </div>
      </template>
    </CustomTable>

    <BModal
      ref="modalCustomer"
      size="lg"
      scrollable
      centered
      hide-header
      no-close-on-esc
      no-enforce-focus
      no-close-on-backdrop
      modal-class="full-height modal-no-padding"
      aria-hidden="false"
      role="dialog"
    >
      <div class="px-2">
        <CustomerInformations
          ref="customerInformations"
          :editing="state.editing"
        />
      </div>

      <template #modal-footer="{ cancel }">
        <BButton
          variant="primary"
          :disabled="state.busy || isFetchingInformationLocations()"
          @click.prevent="validateCustomer"
        >
          {{ state.editing ? 'Update' : 'Register' }} Customer
        </BButton>
        <BButton

          variant="outline-dark"
          :disabled="state.busy"
          @click.prevent="discardBtnEvent => preventAriaHidden(discardBtnEvent, cancel)"
        >
          Discard
        </BButton>
      </template>
    </BModal>
  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'
import { setTableOptions, getTableOptions } from '@/forage/fso/customers'
import { getClusters } from '@/forage/shared/clusters'

import CustomerInformations from '@/views/fso/customer-management/Informations.vue'

import MxMisc from '@/mixins/misc'
import MxFormatter from '@/mixins/formatter'
import MxImageUrl from '@/mixins/image-url'

import { SFSOCustomer } from '@/services/fso'

export default {

  name: 'VFSOCustomers',

  components: {
    CustomerInformations
  },

  mixins: [
    MxMisc,
    MxFormatter,
    MxImageUrl
  ],

  beforeRouteEnter (_to, _from, navigate) {
    getTableOptions().then(options => {
      getClusters().then(
        clusters => {
          navigate(context => {
            if (context.currentUser) {
              if (clusters) {
                context.tableCustomers.options.clusters = clusters
              }

              if (options) {
                const { currentPage, perPage, sortBy, sortDesc, totalRows, filter } = options

                context.tableCustomers = Object.assign(context.tableCustomers, {
                  totalRows: totalRows || 0,
                  sortBy: sortBy || 'id',
                  sortDesc: sortDesc || false,
                  perPage: perPage || 10,
                  currentPage: currentPage || 0,
                  filter: {
                    search: filter.search || '',
                    cluster: ''
                  }
                })

                context.tableCustomers.selected.cluster = clusters.find(
                  cluster => String(cluster.id) === String(filter?.cluster || '')
                ) || ''
              } else {
                context.tableCustomers.currentPage = 1
              }
            }
          })
        }
      )
    })
  },

  middleware: [
    'auth',
    'fso'
  ],

  metaInfo: () => ({
    title: 'Customers'
  }),

  data () {
    return {
      state: {
        busy: false,
        editing: false
      },
      tableCustomers: {
        busy: false,
        options: {
          clusters: [],
          statuses: ['All', 'New', 'Verified']
        },
        selected: {
          cluster: '',
          tagging: 1
        },
        filter: {
          search: '',
          cluster: ''
        },
        filterOn: [],
        stacked: 'sm',
        sortBy: 'id',
        sortDesc: false,
        sortDirection: 'asc',
        pageOptions: [10, 25, 50, 100],
        currentPage: 1,
        totalRows: 0,
        perPage: 10,
        fields: [
          { mobile: 0, key: 'index', label: '#', class: 'text-right stacked-full text-md-center' },
          { mobile: 2, key: 'action', class: 'text-md-center w-md-125px' },
          { mobile: 1, key: 'customer_name', label: 'Customer', class: 'min-w-md-250px', sortable: true }
        ].sort(this.scaleOnMobile)
      }
    }
  },

  computed: {
    ...mapGetters({
      currentUser: 'auth/user'
    })

    // settingFilters () {
    //   const hasEditables = Object.keys(this.tableCustomers.editable).map(
    //     editableKey => this.tableCustomers.editable[editableKey]
    //   ).some(val => String(val) !== '')
    //   return hasEditables
    // }
  },

  watch: {
    'tableCustomers.selected.cluster' (cluster) {
      this.tableCustomers.filter.cluster = cluster?.id || ''
    }
  },

  methods: {

    isFetchingInformationLocations () {
      if (this.$refs.customerInformations?.fetching) {
        const fetching = this.$refs.customerInformations.fetching
        return fetching?.provinces || fetching?.municipalities || fetching?.barangays
      }

      return false
    },

    customerStatus (status) {
      switch (status) {
        case 'Verified': {
          return 'secondary'
        }
        case 'New': {
          return 'primary'
        }
        default: {
          return 'warning'
        }
      }
    },

    async tableProvider ({ currentPage, perPage, sortBy, sortDesc, filter }) {
      this.tableCustomers.busy = true

      const payload = {
        page: currentPage,
        per_page: perPage,
        sort: sortBy,
        sort_desc: sortDesc,
        filter_text: filter.search,
        cluster_id: filter.cluster
      }

      return await SFSOCustomer.get(payload).then(
        ({ data }) => {
          this.tableCustomers.totalRows = data.total_rows
          setTableOptions({
            currentPage,
            perPage,
            sortBy,
            sortDesc,
            filter,
            totalRows: data.total_rows
          })
          return data.items
        }
      ).catch(() => {
        setTableOptions({
          currentPage,
          perPage,
          sortBy,
          sortDesc,
          filter,
          totalRows: 0
        })
        this.tableCustomers.totalRows = 0
        return []
      }).finally(() => {
        this.tableCustomers.busy = false
      })
    },

    createCustomer () {
      this.state.editing = false

      this.$refs.modalCustomer.show()
      this.$refs.modalCustomer.onAfterEnter = () => {
        this.$refs.customerInformations.createInformation()
      }
    },

    validateCustomer () {
      this.$refs.customerInformations.submitInformation().then(
        ({ value }) => {
          if (value?.customer) {
            this.swalConfirm({
              html: 'Navigate to Customer Profile to Add More Information?',
              confirmButtonText: 'Navigate',
              cancelButtonText: 'Stay on Page',
              preConfirm: () => {
                this.$router.push({
                  name: 'fso.customers.profile',
                  params: {
                    customer: value.customer.id
                  }
                })
              }
            }).then(
              ({ isDismissed }) => {
                if (isDismissed) {
                  this.$refs.modalCustomer.hide()
                  this.$refs.tableCustomers.refetch()
                }
              }
            )
          }
        }
      )
    }
  }
}
</script>
